module.exports = __webpack_public_path__ + "static/media/new-vegan-icon.50f8774b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-vegan-icon.png
// module id = 599
// module chunks = 11